import React, { useState } from "react";

function ShowMoreAndLessText({ html, maxLength }) {
    const [showFullContent, setShowFullContent] = useState(false);
    const content = html || ""; // Set content to empty string if html is undefined or empty

    const toggleContent = () => {
        setShowFullContent((prev) => !prev);
    };

    return (
        <div>
            <div
                dangerouslySetInnerHTML={{
                    __html: showFullContent ? content : content.slice(0, maxLength),
                }}
            />
            {content.length > maxLength && (
                <button className={`btn btn-sm ${showFullContent ? "btn-outline-danger" : "btn-outline-success"}`} onClick={toggleContent}>
                    {showFullContent ? "Read less ▲" : "Read more ▼"}
                </button>
            )}
        </div>
    );
}

export default ShowMoreAndLessText;
